import { logger } from '@tuic/logger';
import { cache } from 'react';

import { Account } from '../../index';

export const getClubPoints = async (
  idToken: string,
): Promise<Account.Points | null> => {
  const { data, error } = await Account.getPoints({
    auth: idToken,
  });

  if (error) {
    logger.error("Could not fetch a user's club points.");
    logger.error(error);

    return null;
  }

  return data ?? null;
};

export const memoizedGetClubPoints = cache(getClubPoints);

export const clubJoin = async (
  args: Account.SignUpClubRequst & { idToken: string },
): Promise<boolean> => {
  const { idToken, ...body } = args;

  const { data, error } = await Account.registerClub({
    body,
    auth: idToken,
  });

  if (error) {
    logger.error('[Account] Joining club failed.');
    logger.error(error);

    return false;
  }

  return data?.clubMember === true;
};

export const clubLeave = async (args: {
  idToken: string;
}): Promise<boolean> => {
  const { idToken } = args;

  const { data, error } = await Account.leaveClub({
    auth: idToken,
  });

  if (error) {
    logger.error('[Account] Leaving club failed.');
    logger.error(error);

    return false;
  }

  return data?.success ?? false;
};
